import { IApiSupersetChartListItem, IApiSupersetExploreResponse } from '@cbridge-packages/api-superset';
import { getSearchableColumnsDetailed } from './_helpers/getSearchableColumns';
import { parseDatasourceString } from './_helpers/buildChartDataRequest';
import { ISupersetChartListItem, IChartMetadata } from './superset.interface';

export namespace SupersetTranslator {
  export function fromApiListItem(slice: IApiSupersetChartListItem): ISupersetChartListItem {
    return {
      id: slice.id,
      sliceName: slice.slice_name,
      datasourceId: slice.datasource_id,
      datasourceName: slice.datasource_name_text,
      datasourceType: slice.datasource_type,
    };
  }

  export function fromApiMetadata(result: IApiSupersetExploreResponse['result']): IChartMetadata {
    const { dataset, form_data: formData } = result;

    const datasource = parseDatasourceString(formData.datasource);

    return {
      datasource,
      formData,
      dataset,
      searchableColumns: getSearchableColumnsDetailed(dataset, formData),
    };
  }
}
